module.exports = __webpack_public_path__ + "static/media/salutebellezzaBanner.58d2cbf2.png";